export default "__VITE_ASSET__yLmo0i8h__"